// المسار: src/Cart.js
import React from 'react';

const Cart = ({ cartItems, onCheckout, onClearCart }) => {
  
  // 1. منطق تجميع المنتجات (Grouping) لحساب الكمية
  // نحول القائمة الطويلة [A, B, A, A] إلى [{...A, qty:3}, {...B, qty:1}]
  const groupedItems = Object.values(cartItems.reduce((acc, item) => {
    if (!acc[item.id]) {
      acc[item.id] = { ...item, qty: 1 };
    } else {
      acc[item.id].qty += 1;
    }
    return acc;
  }, {}));

  const total = groupedItems.reduce((acc, item) => acc + (item.price * item.qty), 0);

  // 2. دالة طباعة الفاتورة التفصيلية
  const handlePrintAndCheckout = () => {
    const printWindow = window.open('', '', 'width=800,height=600');
    
    const invoiceHTML = `
      <html>
        <head>
          <title>فاتورة شراء - CPE Tech</title>
          <style>
            body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; direction: rtl; padding: 20px; text-align: center; }
            .header { border-bottom: 2px solid #333; padding-bottom: 20px; margin-bottom: 20px; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th { background-color: #f4f4f4; border: 1px solid #ddd; padding: 10px; }
            td { border: 1px solid #ddd; padding: 10px; }
            .total { font-size: 24px; font-weight: bold; margin-top: 30px; border-top: 2px solid #333; padding-top: 10px; }
            .footer { margin-top: 50px; font-size: 12px; color: #666; }
          </style>
        </head>
        <body>
          <div class="header">
            <h1>CPE Tech - فاتورة شراء</h1>
            <p>بسكرة - أورلال | هاتف: 0770281922</p>
            <p>رقم الفاتورة: #${Math.floor(Date.now() / 1000)}</p>
            <p>التاريخ: ${new Date().toLocaleString()}</p>
          </div>
          <table>
            <thead>
              <tr>
                <th>المنتج</th>
                <th>سعر الوحدة</th>
                <th>الكمية</th>
                <th>الإجمالي</th>
              </tr>
            </thead>
            <tbody>
              ${groupedItems.map(item => `
                <tr>
                  <td>${item.name}</td>
                  <td>${item.price} DZD</td>
                  <td>${item.qty}</td>
                  <td>${item.price * item.qty} DZD</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
          <div class="total">المجموع الكلي: ${total} DZD</div>
          <div class="footer">
            <p>شكراً لتسوقكم معنا!</p>
            <p>يرجى الاحتفاظ بالفاتورة للضمان والاستبدال.</p>
          </div>
          <script>window.print(); window.close();</script>
        </body>
      </html>
    `;

    printWindow.document.write(invoiceHTML);
    printWindow.document.close();
    
    // إتمام الشراء
    onCheckout();
  };

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center', background: 'white', padding: '30px', borderRadius: '15px', boxShadow: '0 5px 15px rgba(0,0,0,0.05)' }}>
      <h2 style={{color: '#1e3a8a'}}>🛒 سلة المشتريات</h2>
      
      {groupedItems.length === 0 ? (
        <div style={{ padding: '50px', color: '#888' }}>
          <h3>السلة فارغة حالياً 😔</h3>
          <p>تصفح المتجر وأضف أفضل العروض!</p>
        </div>
      ) : (
        <>
          <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
            <thead>
              <tr style={{ background: '#f8fafc', color: '#334155' }}>
                <th style={{ padding: '15px', textAlign: 'right' }}>المنتج</th>
                <th style={{ padding: '15px' }}>الكمية</th>
                <th style={{ padding: '15px' }}>سعر الوحدة</th>
                <th style={{ padding: '15px', textAlign: 'left' }}>الإجمالي</th>
              </tr>
            </thead>
            <tbody>
              {groupedItems.map((item, index) => (
                <tr key={index} style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '15px', textAlign: 'right', display: 'flex', alignItems: 'center', gap: '10px' }}>
                     {item.image && item.image.startsWith('data:') ? 
                      <img src={item.image} alt="" style={{width:'40px', height:'40px', borderRadius:'5px'}} /> : 
                      <span style={{fontSize:'24px'}}>{item.image}</span>
                    }
                    {item.name}
                  </td>
                  <td style={{ padding: '15px', fontWeight: 'bold' }}>x {item.qty}</td>
                  <td style={{ padding: '15px', color: '#666' }}>{item.price}</td>
                  <td style={{ padding: '15px', textAlign: 'left', fontWeight: 'bold', color: '#10b981' }}>
                    {item.price * item.qty} DZD
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div style={{ marginTop: '30px', padding: '20px', background: '#f0f9ff', borderRadius: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontSize: '18px' }}>المجموع الكلي:</span>
            <span style={{ fontSize: '24px', fontWeight: 'bold', color: '#1e3a8a' }}>{total} DZD</span>
          </div>

          <div style={{ marginTop: '30px', display: 'flex', gap: '15px', justifyContent: 'center' }}>
            <button onClick={onClearCart} style={{ background: '#ef4444', color: 'white', border: 'none', padding: '12px 25px', borderRadius: '8px', cursor: 'pointer' }}>
              إفراغ السلة 🗑️
            </button>
            <button onClick={handlePrintAndCheckout} style={{ background: '#2563eb', color: 'white', border: 'none', padding: '12px 40px', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold', fontSize: '16px' }}>
              🖨️ طباعة الفاتورة وإتمام الطلب
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default Cart;